import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { submitWithdrawal } from '../fiatWalletEndpoints'
import { fiatWalletKeys } from '../fiatWalletQueryKeys'
import { transactionKeys } from '../../../transactions/api/transactionQueryKeys'

export function useSubmitWithdrawalMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: submitWithdrawal,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: fiatWalletKeys.fiat() })
      // Activity feed is now under the transactions sub-module.
      qc.invalidateQueries({ queryKey: transactionKeys.lists() })
    },
  })
}
